"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  API_ERROR: true,
  ACTIVATE_DATA: true,
  ASSIGN_DATA: true,
  DELETE_DATA: true,
  DELETE_REQUESTS: true,
  MERGE_DATA: true,
  REINITIALIZE_DATA: true,
  REINITIALIZE_REQUESTS: true,
  RESET_DATA: true,
  SERVER_ERROR: true,
  SET_DATA: true,
  activateData: true,
  assignData: true,
  deleteData: true,
  deleteRequests: true,
  createDataReducer: true,
  createRequestsReducer: true,
  fetchData: true,
  getNormalizedCommittedState: true,
  getNormalizedDeletedState: true,
  getNormalizedMergedState: true,
  getStateKeyFromApiPath: true,
  getStateKeyFromConfig: true,
  getStateKeyFromUrl: true,
  getSuccessState: true,
  merge: true,
  mergeData: true,
  purgeData: true,
  reinitializeData: true,
  reinitializeRequests: true,
  resetData: true,
  selectEntitiesByKeyAndTagsAndStrictness: true,
  selectEntitiesByKeyAndJoin: true,
  selectEntityByActivityIdentifier: true,
  selectEntityByKeyAndId: true,
  selectEntityByKeyAndJoin: true,
  selectEntityByKeyAndNormalizer: true,
  selectRequestByConfig: true,
  selectValueByWalk: true,
  setData: true
};
Object.defineProperty(exports, "API_ERROR", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.API_ERROR;
  }
});
Object.defineProperty(exports, "ACTIVATE_DATA", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.ACTIVATE_DATA;
  }
});
Object.defineProperty(exports, "ASSIGN_DATA", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.ASSIGN_DATA;
  }
});
Object.defineProperty(exports, "DELETE_DATA", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.DELETE_DATA;
  }
});
Object.defineProperty(exports, "DELETE_REQUESTS", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.DELETE_REQUESTS;
  }
});
Object.defineProperty(exports, "MERGE_DATA", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.MERGE_DATA;
  }
});
Object.defineProperty(exports, "REINITIALIZE_DATA", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.REINITIALIZE_DATA;
  }
});
Object.defineProperty(exports, "REINITIALIZE_REQUESTS", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.REINITIALIZE_REQUESTS;
  }
});
Object.defineProperty(exports, "RESET_DATA", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.RESET_DATA;
  }
});
Object.defineProperty(exports, "SERVER_ERROR", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.SERVER_ERROR;
  }
});
Object.defineProperty(exports, "SET_DATA", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.SET_DATA;
  }
});
Object.defineProperty(exports, "activateData", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.activateData;
  }
});
Object.defineProperty(exports, "assignData", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.assignData;
  }
});
Object.defineProperty(exports, "deleteData", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.deleteData;
  }
});
Object.defineProperty(exports, "deleteRequests", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.deleteRequests;
  }
});
Object.defineProperty(exports, "createDataReducer", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.createDataReducer;
  }
});
Object.defineProperty(exports, "createRequestsReducer", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.createRequestsReducer;
  }
});
Object.defineProperty(exports, "fetchData", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.fetchData;
  }
});
Object.defineProperty(exports, "getNormalizedCommittedState", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.getNormalizedCommittedState;
  }
});
Object.defineProperty(exports, "getNormalizedDeletedState", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.getNormalizedDeletedState;
  }
});
Object.defineProperty(exports, "getNormalizedMergedState", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.getNormalizedMergedState;
  }
});
Object.defineProperty(exports, "getStateKeyFromApiPath", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.getStateKeyFromApiPath;
  }
});
Object.defineProperty(exports, "getStateKeyFromConfig", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.getStateKeyFromConfig;
  }
});
Object.defineProperty(exports, "getStateKeyFromUrl", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.getStateKeyFromUrl;
  }
});
Object.defineProperty(exports, "getSuccessState", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.getSuccessState;
  }
});
Object.defineProperty(exports, "merge", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.merge;
  }
});
Object.defineProperty(exports, "mergeData", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.mergeData;
  }
});
Object.defineProperty(exports, "purgeData", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.purgeData;
  }
});
Object.defineProperty(exports, "reinitializeData", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.reinitializeData;
  }
});
Object.defineProperty(exports, "reinitializeRequests", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.reinitializeRequests;
  }
});
Object.defineProperty(exports, "resetData", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.resetData;
  }
});
Object.defineProperty(exports, "selectEntitiesByKeyAndTagsAndStrictness", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.selectEntitiesByKeyAndTagsAndStrictness;
  }
});
Object.defineProperty(exports, "selectEntitiesByKeyAndJoin", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.selectEntitiesByKeyAndJoin;
  }
});
Object.defineProperty(exports, "selectEntityByActivityIdentifier", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.selectEntityByActivityIdentifier;
  }
});
Object.defineProperty(exports, "selectEntityByKeyAndId", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.selectEntityByKeyAndId;
  }
});
Object.defineProperty(exports, "selectEntityByKeyAndJoin", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.selectEntityByKeyAndJoin;
  }
});
Object.defineProperty(exports, "selectEntityByKeyAndNormalizer", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.selectEntityByKeyAndNormalizer;
  }
});
Object.defineProperty(exports, "selectRequestByConfig", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.selectRequestByConfig;
  }
});
Object.defineProperty(exports, "selectValueByWalk", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.selectValueByWalk;
  }
});
Object.defineProperty(exports, "setData", {
  enumerable: true,
  get: function get() {
    return _fetchNormalizeData.setData;
  }
});

var _fetchNormalizeData = require("fetch-normalize-data");

var _requestData = require("./requestData");

Object.keys(_requestData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _requestData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _requestData[key];
    }
  });
});